import React, { useState } from "react";
import PageIndex from "../../../PageIndex";
import Index from "../../../Index";
import moment from "moment";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useDispatch } from "react-redux";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { updatePublisherAmount } from "../../../../redux/slices/AdminService";
import ButtonMvpLoader from "../../../../components/common/buttonMvpLoader/ButtonMvpLoader";
import { updatePublisherSchema } from "../../../../validations/Validation";

function PublisherUpdate() {
  const navigate = PageIndex?.useNavigate();
  const params = PageIndex.useLocation();
  const [isDisabled, setIsDisabled] = useState(false);
  const advertiserSingleData = params?.state;
  const initialValues = {
    name: advertiserSingleData?._id ? advertiserSingleData?.name : "",
    email: advertiserSingleData?._id ? advertiserSingleData?.email : "",
    company: advertiserSingleData?._id ? advertiserSingleData?.company : "",
    isApproved: advertiserSingleData?._id
      ? advertiserSingleData?.isApproved
      : "",
    createdAt: advertiserSingleData?._id ? advertiserSingleData?.createdAt : "",
    publishUrl: advertiserSingleData?._id
      ? advertiserSingleData?.publishUrl
      : "",
    publisherCommission: advertiserSingleData?._id
      ? advertiserSingleData?.publisherCommission
      : "",
      walletAdress : advertiserSingleData?._id ? advertiserSingleData.wallets[0]?.smartAccountAddress
      : "",
      walletAmount :advertiserSingleData?._id ? 
      advertiserSingleData?.walletAmount
      : "",
  };

  const dispatch = useDispatch();
  const handleFormSubmit = (values, { resetForm }) => {
    setIsDisabled(true);
    const amountData = {
      publisherCommission: +values.publisherCommission,
      id: advertiserSingleData?._id,
      walletAmount: +values?.walletAmount
    };

    dispatch(updatePublisherAmount(amountData)).then((data) => {
      setTimeout(() => {
        setIsDisabled(false);
      }, 6000);
      if (data?.payload?.status === 200 || data?.payload?.status === 201) {
        setIsDisabled(false);
        navigate("/admin/publisher-list");
        resetForm({
          ...values,
          publisherCommission: ""
        });
      }
    });
  };

  return (
    <Index.Box className="dashboard-content add-user-containt">
      <Index.Typography
        className="admin-page-title main-heading"
        component="h2"
        variant="h2"
      >
        Edit Publisher
      </Index.Typography>
      <Index.Box className="table-bg-main">
        <PageIndex.Formik
          initialValues={initialValues}
          onSubmit={handleFormSubmit}
          validationSchema={updatePublisherSchema}
        >
          {({ values, handleChange, setFieldValue, handleSubmit, errors }) => (
            <PageIndex.Form onSubmit={handleSubmit}>
              <Index.Box className="add-user-data-main">
                <Index.Box sx={{ width: 1 }} className="grid-main">
                  <Index.Box
                    display="grid"
                    className="display-row"
                    gridTemplateColumns="repeat(12, 1fr)"
                    gap={{ xs: 0, sm: 0, md: 0, lg: 0 }}
                  >
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 6",
                        lg: "span 6"
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="input-box add-user-input">
                        <Index.FormHelperText className="form-lable">
                          Name<span>*</span>
                        </Index.FormHelperText>
                        <Index.Box className="form-group">
                          <PageIndex.Field
                            disabled
                            name="name"
                            as={Index.TextField}
                            // label="Carpet Area"
                            variant="outlined"
                            fullWidth
                            id="fullWidth"
                            className="form-control"
                            onChange={(event) => {
                              const inputValue = event.target.value;
                              if (inputValue.length <= 25) {
                                // Only update the value if it's not more than 30 characters
                                handleChange(event);
                              }
                            }}
                          />
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 6",
                        lg: "span 6"
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="input-box add-user-input">
                        <Index.FormHelperText className="form-lable">
                          Company Name<span>*</span>
                        </Index.FormHelperText>
                        <Index.Box className="form-group">
                          <PageIndex.Field
                            disabled
                            name="company"
                            as={Index.TextField}
                            // label="Carpet Area"
                            variant="outlined"
                            fullWidth
                            id="fullWidth"
                            className="form-control"
                            onChange={(event) => {
                              const inputValue = event.target.value;
                              if (inputValue.length <= 10) {
                                // Only update the value if it's not more than 30 characters
                                handleChange(event);
                              }
                            }}
                          />
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 6",
                        lg: "span 6"
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="input-box add-user-input">
                        <Index.FormHelperText className="form-lable">
                          Email<span>*</span>
                        </Index.FormHelperText>
                        <Index.Box className="form-group">
                          <PageIndex.Field
                            disabled
                            name="email"
                            as={Index.TextField}
                            // label="Carpet Area"
                            variant="outlined"
                            fullWidth
                            id="fullWidth"
                            className="form-control"
                            onChange={(event) => {
                              const inputValue = event.target.value;
                              if (inputValue.length <= 10) {
                                // Only update the value if it's not more than 30 characters
                                handleChange(event);
                              }
                            }}
                            onKeyDown={(e) =>
                              e.keyCode === 32 && e.preventDefault()
                            }
                          />
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 6",
                        lg: "span 6"
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="input-box add-user-input">
                        <Index.FormHelperText className="form-lable">
                          Created Date
                        </Index.FormHelperText>
                        <Index.Box className="form-group custom-datepicker ">
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            className="date-adapter-main"
                          >
                            <DemoContainer
                              components={["DatePicker", "DatePicker"]}
                              className="date-adapter-container"
                            >
                              <DatePicker
                                className="date-adapter-picker"
                                disabled
                                name="createdAt"
                                value={dayjs(values.createdAt)}
                                onChange={(e) => {
                                  const formatedDate = moment(e).format(
                                    "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
                                  );
                                  setFieldValue("createdAt", formatedDate);
                                }}
                                format="DD/MM/YYYY"
                                disablePast
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 6",
                        lg: "span 6"
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="input-box add-user-input">
                        <Index.FormHelperText className="form-lable">
                          Status
                        </Index.FormHelperText>
                        <Index.Box className="form-group">
                          <PageIndex.Field
                            disabled
                            name="isApproved"
                            as={Index.TextField}
                            // label="Carpet Area"
                            variant="outlined"
                            fullWidth
                            id="fullWidth"
                            className="form-control"
                            onChange={(event) => {
                              const inputValue = event.target.value;
                              if (inputValue.length <= 10) {
                                // Only update the value if it's not more than 30 characters
                                handleChange(event);
                              }
                            }}
                          />
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 6",
                        lg: "span 6"
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="input-box add-user-input">
                        <Index.FormHelperText className="form-lable">
                          Publisher Url<span>*</span>
                        </Index.FormHelperText>
                        <Index.Box className="form-group">
                          <PageIndex.Field
                            disabled
                            name="publishUrl"
                            as={Index.TextField}
                            // label="Carpet Area"
                            variant="outlined"
                            fullWidth
                            id="fullWidth"
                            className="form-control"
                            onChange={(event) => {
                              const inputValue = event.target.value;
                              if (inputValue.length <= 10) {
                                // Only update the value if it's not more than 30 characters
                                handleChange(event);
                              }
                            }}
                          />
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 6",
                        lg: "span 6"
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="input-box add-user-input">
                        <Index.FormHelperText className="form-lable">
                        Publisher Commission(%)<span>*</span>
                        </Index.FormHelperText>
                        <Index.Box className="form-group">
                          <Index.TextField
                            name="publisherCommission"
                            // as={Index.TextField}
                            value={values?.publisherCommission}
                            // label="Carpet Area"
                            variant="outlined"
                            fullWidth
                            id="fullWidth"
                            className="form-control"
                            type="number"
                            placeholder="Please enter publisher commission"
                            onWheel={(e) => e.target.blur()}
                            onChange={(event) => {
                              let inputValue = event.target.value;
                              inputValue = inputValue.replace(/\s\s+/g, " ");
                              if (inputValue?.length <= 5) {
                                // Only update the value if it's not more than 30 characters
                                handleChange(event);
                              }
                            }}
                          />
                        </Index.Box>
                        {errors?.publisherCommission ? (
                          <Index.Typography className="error-msg">
                            {errors?.publisherCommission}
                          </Index.Typography>
                        ) : null}
                      </Index.Box>
                    </Index.Box>

                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 6",
                        lg: "span 6"
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="input-box add-user-input">
                        <Index.FormHelperText className="form-lable">
                         Wallet Address<span>*</span>
                        </Index.FormHelperText>
                        <Index.Box className="form-group">
                          <PageIndex.Field
                            disabled
                            name="walletAdress"
                            as={Index.TextField}
                            // label="Carpet Area"
                            variant="outlined"
                            fullWidth
                            id="fullWidth"
                            className="form-control"
                            onChange={(event) => {
                              const inputValue = event.target.value;
                              if (inputValue.length <= 10) {
                                // Only update the value if it's not more than 30 characters
                                handleChange(event);
                              }
                            }}
                          />
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 6",
                        lg: "span 6"
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="input-box add-user-input">
                        <Index.FormHelperText className="form-lable">
                        Wallet<span>*</span>
                        </Index.FormHelperText>
                        <Index.Box className="form-group">
                          <Index.TextField
                            name="walletAmount"
                            // as={Index.TextField}
                            value={values?.walletAmount}
                            // label="Carpet Area"
                            variant="outlined"
                            fullWidth
                            id="fullWidth"
                            className="form-control"
                            type="number"
                            placeholder="Please enter wallet"
                            onWheel={(e) => e.target.blur()}
                            onChange={(event) => {
                              let inputValue = event.target.value;
                              inputValue = inputValue.replace(/\s\s+/g, " ");
                              if (inputValue?.length <= 5) {
                                // Only update the value if it's not more than 30 characters
                                handleChange(event);
                              }
                            }}
                          />
                        </Index.Box>
                        {errors?.walletAmount ? (
                          <Index.Typography className="error-msg">
                            {errors?.walletAmount}
                          </Index.Typography>
                        ) : null}
                      </Index.Box>
                    </Index.Box>

                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 12",
                        md: "span 12",
                        lg: "span 12"
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="user-btn-flex">
                        <Index.Box className="discard-btn-main border-btn-main">
                          <Index.Button
                            className="discard-user-btn border-btn"
                            onClick={() => navigate("/admin/publisher-list")}
                          >
                            Back
                          </Index.Button>
                        </Index.Box>
                        <Index.Box className="save-btn-main border-btn-main">
                          <Index.Button
                            className="save-user-btn border-btn"
                            type="submit"
                            disabled={isDisabled}
                          >
                            {isDisabled ? (
                              <ButtonMvpLoader
                                color="white"
                                loading={isDisabled}
                              />
                            ) : (
                              <>
                                <img
                                  alt="imgcategory"
                                  src={PageIndex.Svg.save}
                                  className="user-save-icon"
                                ></img>
                                Update
                              </>
                            )}
                          </Index.Button>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </PageIndex.Form>
          )}
        </PageIndex.Formik>
      </Index.Box>
    </Index.Box>
  );
}

export default PublisherUpdate;
